/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Menu Controls
import { NgcMenuModule } from '../controls/menu/ngc-menu.component';

/**
 * NGC Menu Module
 */

export class NgcMenusModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [
        NgcMenuModule
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
